export function MessagesProvider({ children }) {
    return children;
}

export function useMessages() {
    return { unreadCount: 0, setUnreadCount: () => {} };
}
